
<div class="row" *ngIf="displayMonthEndTenLargestHoldingsSection">
  <h5 class="rps-heading-five">Month end 10 largest holdings</h5>
     <div class="horizontal-scroll-table" *ngIf="portfolioModel?.topTenHoldings; else noData">
      <p class="date rps-paragraph-two rps-grey" *ngIf="portfolioModel?.topTenHoldings?.long?.totalNetAssetPct">{{portfolioModel?.topTenHoldings?.long?.totalNetAssetPct  | VMFPercent}} of total net assets as of {{portfolioModel?.topTenHoldings?.long?.asOfDate | ESTPipe}}</p>
      <p class="date rps-paragraph-two rps-grey" *ngIf="portfolioModel?.topTenHoldings?.short?.totalNetAssetPct">{{portfolioModel?.topTenHoldings?.short?.totalNetAssetPct  | VMFPercent}} of total net assets as of {{portfolioModel?.topTenHoldings?.short?.asOfDate | ESTPipe}}</p>
      <table class="table-results table-hover" aria-label="Top ten monthend holdings">
        <thead>
          <tr>
            <th scope="col">Rank</th>
            <th scope="col">Holdings</th>
            <th scope="col" style="white-space: nowrap;">% of fund</th>
          </tr>
        </thead>
        <tbody>
          <tr  *ngFor="let item of portfolioModel?.topTenHoldings?.long?.item;let i = index" [attr.id]="i">
            <td>{{i+1}}</td>
            <td>{{item?.name }}</td>
            <td>{{item?.netAssetPct | VMFPercent }}</td>
          </tr>
          <tr   *ngFor="let item of portfolioModel?.topTenHoldings?.short?.item;let i = index" [attr.id]="i">
            <td>{{i+1}}</td>
            <td>{{item?.name }}</td>
            <td>{{item?.netAssetPct | VMFPercent }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #noData>
      <p class="no-data">This information is temporarily unavailable.</p>
    </ng-template>
  </div>